import { useMutation } from 'apollo-3';

import { useVideoPlayer } from '../../../Context/VideoPlayer';
import { generateClassroomVideoScreenshotSignedUrl } from '../../../GraphQL/mutation/Classroom.mutation';

export const useByteArkSnapshot = (props) => {
  const { playerRef } = useVideoPlayer();
  const [getScreenshotSignedUrl] = useMutation(generateClassroomVideoScreenshotSignedUrl, props);

  const getUrlImage = async (videoId, currentTimeSecond) => {
    return await getScreenshotSignedUrl({
      variables: {
        videoKey: videoId,
        timeToLive: 900,
        timestamp: parseInt(currentTimeSecond),
      },
      fetchPolicy: 'no-cache',
    });
  };

  const capture = async () => {
    const videoId = playerRef?.props?.src?.videoId;
    const currentTimeSecond = playerRef?.getCurrentTime();
    const { data } = await getUrlImage(videoId, currentTimeSecond);
    const signedUrl = data?.vdmGenerateVideoScreenshotSignedUrl?.signedUrl;

    const response = await fetch(signedUrl);

    const blob = response.status === 200 ? await response.blob() : null;

    const file = {
      source: blob ? URL.createObjectURL(blob) : null,
      file: blob,
      name: 'screenshot.png',
      type: 'image/png',
    };

    return file;
  };

  return { capture };
};

export default useByteArkSnapshot;
